import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home/Home.vue')
        },
        {
          path: '/cobranza',
          name: 'cobranza',
          component: () => import('./views/cobranza/index.vue')
        },
        {
          path: '/cobranza2',
          name: 'cobranza2',
          component: () => import('./views/cobranza2/index.vue')
        },
        {
          path: '/companies',
          name: 'companies',
          component: () => import('./views/general/companies/index')
        },
        {
          path: '/users',
          name: 'users',
          component: () => import('./views/general/users/index')
        },
        {
          path: '/menus',
          name: 'menus',
          component: () => import('./views/general/menus/index')
        },
        {
          path: '/rol',
          name: 'rol',
          component: () => import('./views/general/roles/index')
        },
        {
          path: '/queries',
          name: 'queries',
          component: () => import('./views/Queries/index')
        },
        {
          path: '/reports',
          name: 'reports',
          component: () => import('./views/reports/index')
        },
        {
          path: '/reportSendgrid',
          name: 'reportSendgrid',
          component: () => import('./views/reportSendgrid/index')
        },
        {
          path: '/my_assignments',
          name: 'my_assignments',
          component: () => import('./views/my_assignments/index')
        },
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
